module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Plaid Items")]), _vm._v(" "), _c('p', [_vm._v("Here are your plaid items")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edf3f1ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Items.vue
// module id = 223
// module chunks = 1